<ng-container *ngIf="!isMobile; else mobileCorrespondence">
    <div class="table-list__container table-list__container--photo">
        <div class="table-list__item">{{ photo.ontvangstmoment | dateFormat }}</div>
        <div class="table-list__item">{{ photo.pg_afzender }}</div>
        <div class="table-list__item">{{ photo.document_omschrijving }}</div>

        <div class="table-list__item">
        <span class="table-list__downloads">
            <span class="table-list__download-item">
                 <ins-photo-download [documentId]="photo.cynodocs_document_id"></ins-photo-download>
            </span>
        </span>
        </div>
    </div>
</ng-container>

<ng-template #mobileCorrespondence>
    <div class="table-list__mobile">
        <div class="table-list__mobile-container" [ngClass]="{
        'table-list-container--open': isOpen,
        'table-list__mobile-container--init': photoIndex === 0 && isOpen}">
            <div class="table-list__mobile-item">
                <span class="table-list__item-title table-list__item-title--icon" (click)="toggle()">
                    <span> Afbeelding {{ photoIndex + 1 }}</span>
                    <span>
                        <ng-container *ngIf="isOpen">
                            <div class="correspondence__icon">
                                <svg class="svg-icon svg-icon--xs">
                                    <use href="assets/icons-ui.svg#pijl-down-bold"></use>
                                </svg>
                            </div>
                         </ng-container>
                        <ng-container *ngIf="!isOpen">
                            <div class="correspondence__icon">
                                <svg class="svg-icon svg-icon--xs">
                                    <use href="assets/icons-ui.svg#pijl-up-bold"></use>
                                </svg>
                            </div>
                        </ng-container>
                    </span>
                </span>
                <span class="table-list__item-value">{{ photo.bestandsnaam }}</span>
            </div>
            <div class="table-list__mobile-item">
                <span class="table-list__item-title">Datum</span>
                <span class="table-list__item-value">{{  photo.ontvangstmoment | dateFormat  }}</span>
            </div>
            <div class="table-list__mobile-item">
                <span class="table-list__item-title">Van</span>
                <span class="table-list__item-value">{{  photo.pg_afzender  }}</span>
            </div>
            <div class="table-list__mobile-item">
                <span class="table-list__item-title">Aan</span>
                <span class="table-list__item-value">{{  photo.document_omschrijving  }}</span>
            </div>

            <div class="table-list__mobile-item">
                <span class="table-list__item-title">Download</span>
                <ul class="table-list__list table-list__list--mobile">
                    <li class="table-list__list-item" #downloadItemRef>
                        <div class="table-list__download-item">
                            <ins-photo-download [documentId]="photo.cynodocs_document_id"></ins-photo-download>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>



